import React, {
  useCallback,
  useDeferredValue,
  useEffect,
  useLayoutEffect,
  useState,
} from "react";
import SearchIcon from "@mui/icons-material/Search";
import styles from "./SearchFiters.module.scss";
import { useSearchParams } from "react-router-dom";
import { changeToParams } from "Shared/Utils/search-params";
import classNames from "classnames";

interface Props {
  className?: string;
}

const SearchFilters = ({ className }: Props) => {
  const [currentText, setCurrentText] = useState("");
  const [searchParams, setSearchParams] = useSearchParams();
  const deferredSearchTerm = useDeferredValue(currentText);
  const [debouncedTerm, setDebouncedTerm] = useState(deferredSearchTerm);

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedTerm(deferredSearchTerm);
    }, 200);

    return () => {
      clearTimeout(handler);
    };
  }, [deferredSearchTerm]);

  useEffect(() => {
    const updatedParams = changeToParams("search", debouncedTerm, searchParams);
    setSearchParams(updatedParams);
  }, [debouncedTerm, searchParams, setSearchParams]);

  const handleChange = useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      setCurrentText(event.target.value);
    },
    []
  );

  useLayoutEffect(() => {
    const searchParamValue = searchParams.get("search");
    searchParamValue && setCurrentText(searchParamValue);
  }, []);

  return (
    <div
      className={classNames(styles.containerSearch, !!className && className)}
    >
      <input
        className={styles.containerSearch__searchBox}
        type="text"
        placeholder="Search"
        value={currentText}
        onChange={handleChange}
      />
      {!currentText && (
        <SearchIcon className={styles.containerSearch_iconAbsolute} />
      )}
    </div>
  );
};

export default SearchFilters;
